// ══════════════════════════════════════════════════════
// PeptideVault v6.5 — Protocol Creation Wizard
// 6-step guided flow: Compounds > Schedule > Dose Phases > Breaks > Preview > Review
// ══════════════════════════════════════════════════════

var _wizStep = 0
var _wizData = null

function openProtocolWizard() {
  _wizStep = 0
  _wizData = {
    name: '', peptideId: '', peptideName: '',
    startDate: '', endDate: '',
    frequency: 'daily', weekdays: [],
    doseAmount: '', doseUnit: 'mcg',
    phases: [], breaks: [],
    status: 'upcoming', notes: ''
  }
  S.modal = 'protocolWizard'
  S.modalData = {}
  render()
}

function wizNext() {
  // Validate current step before advancing
  if (_wizStep === 0 && !_wizData.peptideId && !_wizData.name) { showToast('Select a peptide or enter a protocol name'); return }
  if (_wizStep === 1) {
    _wizData.startDate = (document.getElementById('wiz-start')||{}).value || ''
    _wizData.endDate = (document.getElementById('wiz-end')||{}).value || ''
    _wizData.frequency = (document.getElementById('wiz-freq')||{}).value || 'daily'
    if (!_wizData.startDate) { showToast('Start date is required'); return }
    if (_wizData.endDate && _wizData.endDate < _wizData.startDate) { showToast('End date must be after start'); return }
    // Collect weekdays
    _wizData.weekdays = []
    document.querySelectorAll('.wiz-weekday:checked').forEach(function(el) { _wizData.weekdays.push(parseInt(el.value)) })
    if (_wizData.frequency === 'custom' && _wizData.weekdays.length === 0) { showToast('Select at least one weekday'); return }
  }
  if (_wizStep === 2) {
    _wizData.doseAmount = (document.getElementById('wiz-dose')||{}).value || ''
    _wizData.doseUnit = (document.getElementById('wiz-unit')||{}).value || 'mcg'
    // Collect phases
    _wizData.phases = []
    document.querySelectorAll('.wiz-phase-row').forEach(function(row) {
      var name = (row.querySelector('[data-wname]')||{}).value || ''
      var sd = parseInt((row.querySelector('[data-wstart]')||{}).value) || 0
      var ed = parseInt((row.querySelector('[data-wend]')||{}).value) || 0
      var da = (row.querySelector('[data-wdose]')||{}).value || ''
      var du = (row.querySelector('[data-wunit]')||{}).value || 'mcg'
      if (name || da) _wizData.phases.push({ name:name, startDay:sd, endDay:ed, doseAmount:da, doseUnit:du })
    })
  }
  if (_wizStep === 3) {
    _wizData.breaks = []
    document.querySelectorAll('.wiz-break-row').forEach(function(row) {
      var bs = (row.querySelector('[data-bstart]')||{}).value || ''
      var be = (row.querySelector('[data-bend]')||{}).value || ''
      var br = (row.querySelector('[data-breason]')||{}).value || ''
      if (bs && be) _wizData.breaks.push({ startDate:bs, endDate:be, reason:br })
    })
  }
  _wizStep = Math.min(5, _wizStep + 1)
  render()
}

function wizBack() { _wizStep = Math.max(0, _wizStep - 1); render() }

function wizSelectPeptide(id) {
  var pep = (S.peptides||[]).find(function(p){return p.id===id})
  _wizData.peptideId = id
  _wizData.peptideName = pep ? pep.name : ''
  if (!_wizData.name && pep) _wizData.name = pep.name + ' Protocol'
}

function wizSave() {
  _wizData.status = automaticProtocolStatus(_wizData)
  saveProtocol(_wizData)
  _wizData = null
  _wizStep = 0
}

function wizSaveActive() {
  _wizData.status = automaticProtocolStatus(_wizData)
  saveProtocol(_wizData)
  _wizData = null
  _wizStep = 0
}

function renderProtocolWizard() {
  if (!_wizData) return ''
  var steps = ['Compound','Schedule','Dosing','Breaks','Preview','Review']
  var dayNames = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']

  // Step indicator
  var stepBar = '<div style="display:flex;gap:0;margin-bottom:20px">' +
    steps.map(function(s, i) {
      var state = i < _wizStep ? 'done' : i === _wizStep ? 'active' : 'pending'
      var bg = state === 'done' ? 'var(--green)' : state === 'active' ? 'var(--accent)' : 'var(--bg3)'
      var fg = state === 'pending' ? 'var(--text4)' : 'white'
      return '<div style="flex:1;text-align:center;padding:8px 4px;background:'+bg+';color:'+fg+';font-size:11px;font-weight:600;' + (i===0?'border-radius:6px 0 0 6px;':'') + (i===5?'border-radius:0 6px 6px 0;':'') + '">' + (i+1) + '. ' + s + '</div>'
    }).join('') +
  '</div>'

  var body = ''

  // Step 0: Compound
  if (_wizStep === 0) {
    var peptides = (S.peptides||[]).filter(function(p){return !p.archived})
    body = '<h3 style="margin-bottom:12px">Which peptide is this protocol for?</h3>' +
      '<div class="form-group"><label>Protocol Name</label><input class="input" id="wiz-name" value="' + esc(_wizData.name) + '" placeholder="e.g. BPC-157 Healing Cycle" oninput="_wizData.name=this.value"></div>' +
      '<div class="form-group" style="margin-top:10px"><label>Peptide</label><select class="input" onchange="wizSelectPeptide(this.value)">' +
        '<option value="">\\u2014 Select \\u2014</option>' +
        peptides.map(function(px){return '<option value="'+px.id+'" '+(_wizData.peptideId===px.id?'selected':'')+'>'+esc(px.name)+'</option>'}).join('') +
      '</select></div>'
  }

  // Step 1: Schedule
  if (_wizStep === 1) {
    body = '<h3 style="margin-bottom:12px">When does this protocol run?</h3>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">' +
        '<div class="form-group"><label>Start Date</label><input class="input" type="date" id="wiz-start" value="' + esc(_wizData.startDate) + '"></div>' +
        '<div class="form-group"><label>End Date</label><input class="input" type="date" id="wiz-end" value="' + esc(_wizData.endDate) + '"></div>' +
      '</div>' +
      '<div class="form-group" style="margin-top:10px"><label>Frequency</label><select class="input" id="wiz-freq" onchange="document.getElementById(\'wiz-weekdays\').style.display=this.value===\'custom\'?\'flex\':\'none\'">' +
        ['daily','eod','3x-week','weekly','biweekly','custom'].map(function(f){return '<option value="'+f+'" '+(f===_wizData.frequency?'selected':'')+'>'+freqLabel(f)+'</option>'}).join('') +
      '</select></div>' +
      '<div id="wiz-weekdays" style="display:' + (_wizData.frequency==='custom'?'flex':'none') + ';gap:6px;margin-top:8px;flex-wrap:wrap">' +
        dayNames.map(function(name,i) {
          return '<label style="display:flex;align-items:center;gap:3px;font-size:12px;cursor:pointer"><input type="checkbox" class="wiz-weekday" value="'+i+'" '+(_wizData.weekdays.indexOf(i)>=0?'checked':'')+'>'+name+'</label>'
        }).join('') +
      '</div>'
  }

  // Step 2: Dosing & Phases
  if (_wizStep === 2) {
    body = '<h3 style="margin-bottom:12px">What dose? Any phase changes?</h3>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">' +
        '<div class="form-group"><label>Default Dose</label><input class="input" type="number" step="any" id="wiz-dose" value="' + esc(_wizData.doseAmount) + '"></div>' +
        '<div class="form-group"><label>Unit</label><select class="input" id="wiz-unit">' +
          ['mcg','mg','mL','IU','units','sprays','drops'].map(function(u){return '<option value="'+u+'" '+(u===_wizData.doseUnit?'selected':'')+'>'+u+'</option>'}).join('') +
        '</select></div>' +
      '</div>' +
      '<div style="margin-top:14px;border-top:1px solid var(--border);padding-top:10px">' +
        '<div class="row" style="margin-bottom:8px"><span style="font-size:13px;font-weight:600">Dose Phases</span><div class="spacer"></div><button class="btn btn-ghost btn-xs" onclick="addWizPhaseRow()">+ Add Phase</button></div>' +
        '<div style="font-size:11px;color:var(--text4);margin-bottom:6px">Optional. Define ramp-up/maintenance/taper by day number.</div>' +
        '<div id="wiz-phases">' +
          (_wizData.phases||[]).map(function(ph) {
            return '<div class="wiz-phase-row" style="display:grid;grid-template-columns:2fr 1fr 1fr 1fr 1fr auto;gap:6px;align-items:end;margin-bottom:6px">' +
              '<div class="form-group"><input class="input" style="font-size:12px" data-wname value="'+esc(ph.name||'')+'" placeholder="Phase name"></div>' +
              '<div class="form-group"><input class="input" style="font-size:12px" type="number" data-wstart value="'+(ph.startDay||0)+'" placeholder="Start day"></div>' +
              '<div class="form-group"><input class="input" style="font-size:12px" type="number" data-wend value="'+(ph.endDay||0)+'" placeholder="End day"></div>' +
              '<div class="form-group"><input class="input" style="font-size:12px" type="number" step="any" data-wdose value="'+(ph.doseAmount||'')+'" placeholder="Dose"></div>' +
              '<div class="form-group"><select class="input" style="font-size:12px" data-wunit>'+['mcg','mg','mL','IU','units','sprays','drops'].map(function(u){return '<option '+(u===(ph.doseUnit||'mcg')?'selected':'')+'>'+u+'</option>'}).join('')+'</select></div>' +
              '<button class="btn btn-ghost btn-xs" onclick="this.closest(\'.wiz-phase-row\').remove()" style="color:var(--red)">\u2715</button>' +
            '</div>'
          }).join('') +
        '</div>' +
      '</div>'
  }

  // Step 3: Breaks
  if (_wizStep === 3) {
    body = '<h3 style="margin-bottom:12px">Any planned breaks?</h3>' +
      '<div style="font-size:12px;color:var(--text3);margin-bottom:12px">Breaks are date ranges where no doses are scheduled.</div>' +
      '<div class="row" style="margin-bottom:8px"><div class="spacer"></div><button class="btn btn-ghost btn-xs" onclick="addWizBreakRow()">+ Add Break</button></div>' +
      '<div id="wiz-breaks">' +
        (_wizData.breaks||[]).map(function(br) {
          return '<div class="wiz-break-row" style="display:grid;grid-template-columns:1fr 1fr 2fr auto;gap:6px;align-items:end;margin-bottom:6px">' +
            '<div class="form-group"><label style="font-size:11px">Start</label><input class="input" style="font-size:12px" type="date" data-bstart value="'+esc(br.startDate||'')+'"></div>' +
            '<div class="form-group"><label style="font-size:11px">End</label><input class="input" style="font-size:12px" type="date" data-bend value="'+esc(br.endDate||'')+'"></div>' +
            '<div class="form-group"><label style="font-size:11px">Reason</label><input class="input" style="font-size:12px" data-breason value="'+esc(br.reason||'')+'"></div>' +
            '<button class="btn btn-ghost btn-xs" onclick="this.closest(\'.wiz-break-row\').remove()" style="color:var(--red)">\u2715</button>' +
          '</div>'
        }).join('') +
      '</div>' +
      ((_wizData.breaks||[]).length === 0 ? '<div style="color:var(--text4);font-size:12px;text-align:center;padding:16px">No breaks \u2014 protocol runs continuously. Click + to add one.</div>' : '')
  }

  // Step 4: Inventory Preview
  if (_wizStep === 4) {
    var preview = resolveProtocolSchedule(_wizData)
    var totalDoses = preview.length
    var totalMg = preview.reduce(function(s,e){return s + (e.doseMg||0)},0)
    var canCalc = preview.length > 0 && preview[0].doseMg !== null
    var pep = (S.peptides||[]).find(function(p){return p.id===_wizData.peptideId})
    var onHand = pep ? peptideQty(pep) : 0

    body = '<h3 style="margin-bottom:12px">Inventory Preview</h3>' +
      '<div style="font-size:12px;color:var(--text3);margin-bottom:12px">This is advisory \u2014 no changes until you save.</div>' +
      '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(120px,1fr));gap:10px;margin-bottom:16px">' +
        '<div class="card" style="padding:12px;text-align:center"><div style="font-size:20px;font-weight:700">' + totalDoses + '</div><div style="font-size:10px;color:var(--text4)">Planned Doses</div></div>' +
        '<div class="card" style="padding:12px;text-align:center"><div style="font-size:20px;font-weight:700">' + (canCalc ? totalMg.toFixed(1)+' mg' : 'N/A') + '</div><div style="font-size:10px;color:var(--text4)">Total Required</div></div>' +
        '<div class="card" style="padding:12px;text-align:center"><div style="font-size:20px;font-weight:700;color:var(--blue)">' + onHand + '</div><div style="font-size:10px;color:var(--text4)">On Hand</div></div>' +
      '</div>' +
      (preview.length > 0 ? '<div style="font-size:11px;color:var(--text4);margin-bottom:6px">First 10 scheduled dates:</div>' +
        '<div style="font-size:12px;color:var(--text3);max-height:150px;overflow-y:auto">' +
          preview.slice(0,10).map(function(e) {
            return '<div style="padding:3px 0;border-bottom:1px solid var(--border)">' + e.date + ' \u2014 ' + e.doseAmount + ' ' + e.doseUnit + (e.phaseName ? ' <span style="color:var(--accent)">(' + e.phaseName + ')</span>' : '') + '</div>'
          }).join('') +
          (preview.length > 10 ? '<div style="padding:3px 0;color:var(--text4)">+' + (preview.length-10) + ' more dates</div>' : '') +
        '</div>' : '<div style="color:var(--amber);font-size:12px">No scheduled dates \u2014 check frequency and date range.</div>')
  }

  // Step 5: Review
  if (_wizStep === 5) {
    var preview2 = resolveProtocolSchedule(_wizData)
    body = '<h3 style="margin-bottom:12px">Review Protocol</h3>' +
      '<div style="background:var(--bg3);border-radius:var(--r2);padding:14px;font-size:13px;line-height:1.8">' +
        '<div><b>Name:</b> ' + esc(_wizData.name || _wizData.peptideName) + '</div>' +
        '<div><b>Peptide:</b> ' + esc(_wizData.peptideName || '\u2014') + '</div>' +
        '<div><b>Schedule:</b> ' + esc(_wizData.startDate) + ' \u2192 ' + esc(_wizData.endDate || 'ongoing') + ' \u00b7 ' + freqLabel(_wizData.frequency) + '</div>' +
        (_wizData.frequency === 'custom' && _wizData.weekdays.length > 0 ? '<div><b>Days:</b> ' + _wizData.weekdays.map(function(d){return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d]}).join(', ') + '</div>' : '') +
        '<div><b>Dose:</b> ' + esc(_wizData.doseAmount) + ' ' + esc(_wizData.doseUnit) + '</div>' +
        (_wizData.phases.length > 0 ? '<div><b>Phases:</b> ' + _wizData.phases.map(function(ph){return esc(ph.name||'Phase')+' (day '+ph.startDay+'-'+ph.endDay+': '+ph.doseAmount+' '+ph.doseUnit+')'}).join(', ') + '</div>' : '') +
        (_wizData.breaks.length > 0 ? '<div><b>Breaks:</b> ' + _wizData.breaks.map(function(br){return esc(br.startDate)+' to '+esc(br.endDate)+(br.reason?' ('+esc(br.reason)+')':'')}).join(', ') + '</div>' : '') +
        '<div><b>Total doses:</b> ' + preview2.length + '</div>' +
        (_wizData.notes ? '<div><b>Notes:</b> ' + esc(_wizData.notes) + '</div>' : '') +
      '</div>' +
      '<div class="form-group" style="margin-top:10px"><label>Notes (optional)</label><textarea class="input" rows="2" onchange="_wizData.notes=this.value">' + esc(_wizData.notes) + '</textarea></div>'
  }

  // Navigation buttons
  var nav = '<div class="row" style="gap:8px;margin-top:20px;justify-content:flex-end">' +
    '<button class="btn btn-secondary" onclick="closeModal()">Cancel</button>' +
    (_wizStep > 0 ? '<button class="btn btn-secondary" onclick="wizBack()">Back</button>' : '') +
    (_wizStep < 5 ? '<button class="btn btn-primary" onclick="wizNext()">Next</button>' : '') +
    (_wizStep === 5 ? '<button class="btn btn-primary" onclick="wizSave()">Save Protocol</button>' : '') +
  '</div>'

  return '<div class="modal modal-lg protocol-wizard" onclick="event.stopPropagation()">' +
    '<div class="modal-hdr"><h3>New Protocol</h3><button class="btn btn-ghost btn-xs" onclick="closeModal()" aria-label="Close">✕</button></div>' +
    '<div class="modal-body">' + stepBar + body + nav + '</div>' +
  '</div>'
}

function addWizPhaseRow() {
  var container = document.getElementById('wiz-phases')
  if (!container) return
  var row = document.createElement('div')
  row.className = 'wiz-phase-row'
  row.style.cssText = 'display:grid;grid-template-columns:2fr 1fr 1fr 1fr 1fr auto;gap:6px;align-items:end;margin-bottom:6px'
  row.innerHTML = '<div class="form-group"><input class="input" style="font-size:12px" data-wname placeholder="Phase name"></div><div class="form-group"><input class="input" style="font-size:12px" type="number" data-wstart value="0"></div><div class="form-group"><input class="input" style="font-size:12px" type="number" data-wend value="7"></div><div class="form-group"><input class="input" style="font-size:12px" type="number" step="any" data-wdose></div><div class="form-group"><select class="input" style="font-size:12px" data-wunit><option>mcg</option><option>mg</option><option>mL</option><option>IU</option><option>units</option><option>sprays</option><option>drops</option></select></div><button class="btn btn-ghost btn-xs" onclick="this.closest(\'.wiz-phase-row\').remove()" style="color:var(--red)">\u2715</button>'
  container.appendChild(row)
}

function addWizBreakRow() {
  var container = document.getElementById('wiz-breaks')
  if (!container) return
  var row = document.createElement('div')
  row.className = 'wiz-break-row'
  row.style.cssText = 'display:grid;grid-template-columns:1fr 1fr 2fr auto;gap:6px;align-items:end;margin-bottom:6px'
  row.innerHTML = '<div class="form-group"><label style="font-size:11px">Start</label><input class="input" style="font-size:12px" type="date" data-bstart></div><div class="form-group"><label style="font-size:11px">End</label><input class="input" style="font-size:12px" type="date" data-bend></div><div class="form-group"><label style="font-size:11px">Reason</label><input class="input" style="font-size:12px" data-breason></div><button class="btn btn-ghost btn-xs" onclick="this.closest(\'.wiz-break-row\').remove()" style="color:var(--red)">\u2715</button>'
  container.appendChild(row)
}

export {
  _wizStep,
  _wizData,
  openProtocolWizard,
  wizNext,
  wizBack,
  wizSelectPeptide,
  wizSave,
  wizSaveActive,
  renderProtocolWizard,
  addWizPhaseRow,
  addWizBreakRow
}
